<article class="ui-image-carousel">
  <div
    class="ui-image-carousel__track"
    (pointerdown)="onSwipeStart($event)"
    (pointerup)="onSwipeEnd($event)"
    (pointercancel)="onSwipeEnd($event)"
  >
    <div class="ui-image-carousel__slide">
      <div
        class="ui-image-carousel__reel"
        [class.ui-image-carousel__reel--pair]="incomingIndex() !== null"
        [class.ui-image-carousel__reel--next]="
          incomingIndex() !== null && direction() === 'next'
        "
        [class.ui-image-carousel__reel--prev]="
          incomingIndex() !== null && direction() === 'prev'
        "
        [class.ui-image-carousel__reel--run]="pushing()"
        (transitionend)="onPushEnd($event)"
      >
        @for (frame of frames(); track frame.index) {
          <div class="ui-image-carousel__frame">
            <picture class="ui-image-carousel__picture">
              @if (frame.slide.wideSrc; as wideSrc) {
                <source [attr.media]="shortMedia" [srcset]="wideSrc" />
              }
              @if (frame.slide.compactSrc; as compactSrc) {
                <source [attr.media]="compactMedia" [srcset]="compactSrc" />
              }
              @if (frame.slide.wideSrc; as wideSrc) {
                <source [attr.media]="wideMedia" [srcset]="wideSrc" />
              }
              <img
                class="ui-image-carousel__image"
                [src]="frame.slide.src"
                [alt]="altPrefix() + ' ' + (frame.index + 1)"
              />
            </picture>
          </div>
        }
      </div>

      <button
        type="button"
        class="ui-image-carousel__nav ui-image-carousel__nav--prev"
        aria-label="Promoción anterior"
        (click)="showPrevious()"
      >
        <svg
          class="ui-image-carousel__nav-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M14.5 6.5 9 12l5.5 5.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <button
        type="button"
        class="ui-image-carousel__nav ui-image-carousel__nav--next"
        aria-label="Promoción siguiente"
        (click)="showNext()"
      >
        <svg
          class="ui-image-carousel__nav-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M9.5 6.5 15 12l-5.5 5.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <div class="ui-image-carousel__pagination" aria-label="Seleccionar promoción">
        @for (slide of slides(); track slide.src; let index = $index) {
          <button
            type="button"
            class="ui-image-carousel__dot"
            [class.ui-image-carousel__dot--active]="normalizedIndex() === index"
            [attr.aria-label]="'Mostrar promoción ' + (index + 1)"
            [attr.aria-current]="normalizedIndex() === index ? 'true' : null"
            (click)="setActiveIndex(index)"
          ></button>
        }
      </div>
    </div>
  </div>
</article>
